<template src="./template.html"></template>
<style lang="scss" src="./login.scss"></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import { changeEventOnAutofillFields } from '@/helper'
  import MetaPage from '@/components/layout/MetaPage'
  import RegistrationTile from '@/components/layout/RegistrationTile'
  import SocialLoginOptions from '@/components/modules/SocialLoginOptions'

  export default {
    name: 'LoginPage',
    components: {
      MetaPage,
      RegistrationTile,
      SocialLoginOptions,
    },
    metaInfo() {
      return {
        title: this.$t('meta.login.title'),
      }
    },
    data() {
      return {
        username: '',
        password: '',
        nda: false,
        nda_required: false,
        nda_required_error: false,
        pages: {},
      }
    },
    computed: {
      ...mapState('auth', [
        'errors',
        'pending',
        'selected_language',
        'signup_config',
        'settings',
        'auth_redirect',
      ]),
      ...mapState('pages', [ 'legal_pages' ]),
    },
    created() {
      // mock input change event for autofill fields
      changeEventOnAutofillFields()
    },
    mounted() {
      if (this.auth_redirect) {
        window.location.href = this.auth_redirect
      }
      this.getLegalPages().then(_ => {
        this.setPages()
      })
    },
    destroyed() {
      this.clearAuthError()
    },
    methods: {
      ...mapActions('auth', [
        'login',
        'initAuth',
        'acceptNdaAgb',
        'setFieldErrors',
      ]),
      ...mapActions('auth', ['clearAuthError']),
      ...mapActions('pages', [ 'getLegalPages' ]),
      getNdaLabel(pages) {
        return this.$t('my_account.register').agb_html ?
          this.$t('my_account.register.agb_html', pages) :
          this.$t('registration_slider').checkout_screen ?
            this.$t('registration_slider.checkout_screen.agb_html', pages) :
            this.$t('login.nda_label', pages)
      },
      onSubmit() {
        this.$refs.form.validate().then(_ => {
          if (!this.$refs.form.flags.valid || this.$refs.form.flags.invalid) {
            this.setFieldErrors([this.$t('errors.messages.required_fields')])
            return false
          }
          this.login({ username: this.username, password: this.password }).then(async data => {
            if (this.errors.length) return false

            if (!data.agb_nda_accepted && !this.nda_required) {
              this.nda_required = true
              this.nda_required_error = true
              return false
            } else if (this.nda) {
              await this.acceptNdaAgb()
            } else if (this.nda_required && !this.nda) {
              return false
            }
            await this.initAuth()
            const lang = this.selected_language || this.$i18n.formatedLocale
            if (this.$route.query.redirect) {
              // redirect hook for login to matching user settings selected_language
              window.location.href = `/${lang}/${this.$route.query.redirect}`
            } else if (this.$route.query.next) {
              // Redirect hook for media urls
              window.location.href = this.$route.query.next
            } else {
              // use window location to enforce a full re-init of the app
              window.location.href = `/${lang}/`
            }
          })
        })
      },
      setPages() {
        Object.entries(this.legal_pages).forEach(page => {
          this.pages[page[0]] = this.$router.resolve({ name: 'page', params: { id: page[1].page_id } }).href || ''
        })
      },
    },
  }
</script>
